function pad(n) {
  return String(n).padStart(2, '0')
}

// DD-MM-YYYY, or 'long' for "Month D, YYYY"
// Reads the date in UTC: values are calendar dates (backend serializes them as UTC midnight),
// so reading with local getters would shift the day for negative-UTC-offset timezones.
export function formatDate(value, format) {
  if (!value) return ''
  const d = new Date(value)
  if (format === 'long') {
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
  }
  return `${pad(d.getUTCDate())}-${pad(d.getUTCMonth() + 1)}-${d.getUTCFullYear()}`
}

// DD-MM-YYYY H:MM am/pm
export function formatDateTime(value) {
  if (!value) return ''
  const d = new Date(value)
  const hours24 = d.getHours()
  const ampm = hours24 >= 12 ? 'pm' : 'am'
  const hours12 = hours24 % 12 || 12
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${hours12}:${pad(d.getMinutes())} ${ampm}`
}

// Weekday DD Month YYYY
export function formatLongDate(value) {
  if (!value) return ''
  const d = new Date(String(value).replace(' ', 'T'))
  return d.toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
}

// Weekday DD Month YYYY at H:MM am/pm
export function formatLongDateTime(value) {
  if (!value) return ''
  const d = new Date(String(value).replace(' ', 'T'))
  const hours24 = d.getHours()
  const ampm = hours24 >= 12 ? 'pm' : 'am'
  const hours12 = hours24 % 12 || 12
  return `${formatLongDate(value)} at ${hours12}:${pad(d.getMinutes())} ${ampm}`
}



// WEBPACK FOOTER //
// ./src/utils/date.js